import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ToggleDisplay from 'react-toggle-display';
import {
  customerRedemptionHistoriesRequest,
  customerPointActivitiesRequest,
  pageRequest,
} from 'actions/customers/list';
import { loadLoyaltySubscription } from 'actions/customers/loyalty/loyaltySubscription';
import _ from 'lodash';
import ListLoyalty from './ListLoyalty';
import ListNonLoyalty from './ListNonLoyalty';
import RedeemHistory from './RedeemHistory';
import PurchaseHistory from './PurchaseHistory';
import PointActivity from './PointActivity';
import Subscribe from '../Loyalty/Subscribe';

class CustomerList extends Component {
  constructor(props) {
    super(props);

    const views = {
      loyalty: 'loyalty',
      nonLoyalty: 'nonLoyalty',
      redeemHistory: 'redeemHistory',
      purchaseHistory: 'purchaseHistory',
      pointActivity: 'pointActivity',
      subscribe: 'subscribe',
    };
    let currentView = '';

    if (this.props.hasLoyalty) {
      currentView = views.loyalty;
    } else if (this.props.hasLoyalty === false) {
      currentView = views.nonLoyalty;
    }

    this.state = { views, currentView };
  }

  componentDidMount() {
    const { billingNotification } = this.props;

    this.props.pageRequest();
    this.props.loadLoyaltySubscription(billingNotification);
  }

  componentWillReceiveProps(nextProps) {
    const { currentView, views } = this.state;
    if (currentView === views.subscribe) {
      return;
    }

    if (this.props.hasLoyalty !== nextProps.hasLoyalty) {
      if (nextProps.hasLoyalty) {
        this.setState({ currentView: views.loyalty });
      } else {
        this.setState({ currentView: views.nonLoyalty });
      }
    }
  }

  render() {
    const { views, currentView } = this.state;
    const {
      hasLoyalty,
      loyaltySubscription,
      trialEndAt,
      outletSlot,
      alreadySubscribed,
      isOwner,
    } = this.props;

    if (
      hasLoyalty === null ||
      loyaltySubscription.pageOnLoading ||
      _.isEmpty(loyaltySubscription.subscriptionDetail)
    ) {
      return null;
    }

    return (
      <div style={{ height: '100%' }}>
        <ToggleDisplay
          show={
            currentView === views.loyalty || currentView === views.nonLoyalty
          }
        >
          {this.props.hasLoyalty && (
            <ListLoyalty
              showRedeemHistory={this._showRedeemHistory}
              showPurchaseHistory={this._showPurchaseHistory}
              showPointActivity={this._showPointActivity}
              loyaltySubscription={loyaltySubscription}
              goToSubscribeView={this._showSubscribe}
            />
          )}
          {!this.props.hasLoyalty && (
            <ListNonLoyalty
              loyaltySubscription={loyaltySubscription}
              goToSubscribeView={this._showSubscribe}
              showPurchaseHistory={this._showPurchaseHistory}
            />
          )}
        </ToggleDisplay>
        {views.redeemHistory === currentView && (
          <RedeemHistory backToCustomerList={this._showListLoyalty} />
        )}
        {views.purchaseHistory === currentView && (
          <PurchaseHistory backToCustomerList={this._showListLoyalty} />
        )}
        {views.pointActivity === currentView && (
          <PointActivity backToCustomerList={this._showListLoyalty} />
        )}
        {views.subscribe === currentView && (
          <Subscribe
            loyaltySubscription={loyaltySubscription}
            trialEndAt={trialEndAt}
            outletSlot={outletSlot}
            alreadySubscribed={alreadySubscribed}
            isOwner={isOwner}
            onClickCancel={this._showCustomerList}
            afterSubscribe={this._showCustomerList}
            goToSubscribeView={this._showSubscribe}
          />
        )}
      </div>
    );
  }

  _showPointActivity = customerId => {
    this.props.customerPointActivitiesRequest({
      customerId,
      page: 1,
      size: 12,
      sort: 'createdAt,desc',
    });
    this.setState({ currentView: this.state.views.pointActivity });
  };

  _showRedeemHistory = customerId => {
    this.props.customerRedemptionHistoriesRequest({
      customerId,
      page: 1,
      size: 12,
      sort: 'createdAt,desc',
    });
    this.setState({ currentView: this.state.views.redeemHistory });
  };

  _showListLoyalty = () => {
    this.setState({ currentView: this.state.views.loyalty });
  };

  // the behaviour of purchase history is different because there is not server side pagination provided
  _showPurchaseHistory = () => {
    this.setState({ currentView: this.state.views.purchaseHistory });
  };

  _showSubscribe = () => {
    this.setState({ currentView: this.state.views.subscribe });
  };

  _showCustomerList = () => {
    if (this.props.hasLoyalty) {
      this.setState({ currentView: this.state.views.loyalty });
    } else {
      this.setState({ currentView: this.state.views.nonLoyalty });
    }
  };
}

CustomerList.propTypes = {
  hasLoyalty: PropTypes.object,
};

function mapStateToProps(state) {
  const {
    already_subscribed,
    business: { trial_end_at, outlet_slot },
    is_owner,
  } = state.moka.user;
  const {
    customers: {
      list: { hasLoyalty, summary },
      loyaltySubscription,
    },
    billingNotification,
  } = state;

  return {
    alreadySubscribed: already_subscribed,
    trialEndAt: trial_end_at,
    outletSlot: outlet_slot,
    isOwner: is_owner,
    billingNotification,

    hasLoyalty,
    summary,
    loyaltySubscription,
  };
}

export default connect(
  mapStateToProps,
  {
    customerRedemptionHistoriesRequest,
    customerPointActivitiesRequest,
    pageRequest,
    loadLoyaltySubscription,
  }
)(CustomerList);
